t = require('app/scripts/views/internal/teacup-with-helpers')('member_detail_profile_info')

module.exports = ->
  t.div '.tabbed-pane-header-content', ->
    t.a class: t.classify('tabbed-pane-header-image': true, 'profile-image': true), href: '#', ->
      if t.mustacheVar('avatarUrl')
        t.img '.profile-image-image', src: t.mustacheVar('avatarUrl'), alt: t.mustacheVar('fullName')
      else if t.mustacheVar('initials')
        t.span '.profile-image-initials', ->
          t.text t.mustacheVar('initials')
      else
        t.div '.member-icon-container', ->
          t.icon 'member'

    t.div '.tabbed-pane-header-details', ->
      t.div '.tabbed-pane-header-details-name', ->

        if t.mustacheVar('fullName') != t.mustacheVar('username')
          t.h1 '.u-inline', ->
            t.text t.mustacheVar('fullName')

        t.p '.window-title-extra.quiet', ->
          t.format 'at-username', { username: t.mustacheVar('username') }

        t.mustacheBlock 'hasCrown', ->
          t.span '.member-profile-gold-badge', ->
            t.icon 'trello-gold', { class: 'member-profile-gold-badge-icon' }
            t.mustacheBlock '__ed', ->
              t.format 'you-ve-got-trello-gold'
            t.mustacheBlockInverted '__ed', ->
              t.format 'has-trello-gold'

      t.div '.tabbed-pane-header-details-content.markeddown', { dir: 'auto' }, ->
        t.mustacheBlock 'bioHtml', ->
          t.raw t.mustacheVar('bioHtml')
